module.exports = __webpack_public_path__ + "static/img/3.c762b5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/3/zh/3.png
// module id = UOxw
// module chunks = 0